var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 15.6724C10.5254 15.6724 10.8989 15.2183 11.1699 14.5151L15.9673 1.9834C16.0991 1.64648 16.1724 1.34619 16.1724 1.09717C16.1724 0.621094 15.8794 0.328125 15.4033 0.328125C15.1543 0.328125 14.854 0.401367 14.5171 0.533203L1.91943 5.35986C1.3042 5.59424 0.828125 5.96777 0.828125 6.50244C0.828125 7.17627 1.34082 7.40332 2.04395 7.61572L7.33203 9.16846L8.87012 14.3906C9.08984 15.1304 9.31689 15.6724 9.99805 15.6724ZM7.66162 8.05518L2.60791 6.50977C2.49072 6.47314 2.4541 6.44385 2.4541 6.39258C2.4541 6.34131 2.4834 6.30469 2.59326 6.26074L12.4956 2.51074C13.0815 2.29102 13.6455 1.99805 14.1875 1.74902C13.7041 2.14453 13.1035 2.61328 12.7007 3.01611L7.66162 8.05518ZM10.1152 14.061C10.0566 14.061 10.0273 14.0098 9.99072 13.8926L8.44531 8.83887L13.4844 3.7998C13.8799 3.4043 14.3706 2.78906 14.7588 2.29102C14.5098 2.84766 14.2095 3.41162 13.9897 4.00488L10.2397 13.9072C10.1958 14.0171 10.1665 14.061 10.1152 14.061Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Send.d74c364e44e7f6b932e6440736869dad.svg";